import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg404 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 175,
	height: 150,
	viewBox: "0 0 175 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M131.666 15.5003L131.67 15.5002C135.455 15.4684 138.5 18.6217 138.5 22.5517V139.233C138.5 141.174 137.389 143.759 135.744 145.881C134.928 146.933 133.999 147.846 133.045 148.493C132.087 149.142 131.137 149.5 130.267 149.5H43.7328C41.8823 149.5 39.8181 148.451 38.1994 146.853C36.5811 145.257 35.5 143.203 35.5 141.304V24.9387C35.5 21.8033 36.9857 19.4543 38.9662 17.8758C40.9601 16.2866 43.4315 15.5003 45.3206 15.5003L131.666 15.5003Z",
			fill: "#1D1D1D",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.666 15.5003L131.67 15.5002C135.469 15.4692 138.5 18.5365 138.5 22.328V138.672C138.5 142.46 135.438 145.5 131.699 145.5H42.3006C38.5314 145.5 35.5 142.43 35.5 138.672V22.328C35.5 18.5403 38.5617 15.5003 42.3006 15.5003L131.666 15.5003Z",
			fill: "#E5E7EB",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.875 49.7739L113.884 49.7605L113.891 49.7464C114.502 48.6571 115.093 47.5512 115.664 46.4402C115.584 47.9964 115.5 49.7166 115.5 50.9902V54.7589H110.645L113.875 49.7739ZM115.5 67.8299V68.3299H116H123.285H123.785V67.8299V61.0457H126.883H127.383V60.5457V55.2589V54.7589H126.883H123.785V38.6542V38.1542H123.285H113.631H113.363L113.215 38.3771L101.849 55.4518L101.765 55.5776V55.7288V60.5457V61.0457H102.265H115.5V67.8299Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.7607 53.105C74.7607 58.1888 75.9506 62.1305 78.078 64.8119C80.2163 67.5072 83.2625 68.8782 86.8458 68.8782C90.4294 68.8782 93.4651 67.5069 95.5925 64.8109C97.7085 62.1293 98.8869 58.1878 98.8869 53.105C98.8869 48.0416 97.7084 44.1751 95.588 41.565C93.4567 38.9412 90.4204 37.6451 86.8458 37.6451C83.2726 37.6451 80.2256 38.9303 78.0827 41.5489C75.9506 44.1543 74.7607 48.0214 74.7607 53.105ZM90.5146 53.105C90.5146 57.0815 90.0525 59.4489 89.3573 60.8076C89.0151 61.4762 88.6252 61.8832 88.2204 62.127C87.8154 62.3709 87.3585 62.4739 86.8458 62.4739C86.3331 62.4739 85.8726 62.3709 85.4628 62.1261C85.0532 61.8814 84.6581 61.4735 84.311 60.8049C83.6059 59.4469 83.133 57.0803 83.133 53.105C83.133 49.1478 83.6065 46.8446 84.3074 45.5441C84.6514 44.9058 85.0428 44.523 85.4506 44.2948C85.8607 44.0653 86.3247 43.9712 86.8458 43.9712C87.3669 43.9712 87.8274 44.0653 88.2326 44.294C88.6355 44.5213 89.0217 44.9031 89.3608 45.5414C90.052 46.8426 90.5146 49.1466 90.5146 53.105Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.1986 49.7739L58.2073 49.7605L58.2152 49.7464C58.8255 48.6571 59.4164 47.5512 59.9878 46.4402C59.9074 47.9964 59.8242 49.7166 59.8242 50.9902V54.7589H54.9687L58.1986 49.7739ZM59.8242 67.8299V68.3299H60.3242H67.6087H68.1087V67.8299V61.0457H71.2071H71.7071V60.5457V55.2589V54.7589H71.2071H68.1087V38.6542V38.1542H67.6087H57.9545H57.6867L57.5383 38.3771L46.1726 55.4518L46.0889 55.5776V55.7288V60.5457V61.0457H46.5889H59.8242V67.8299Z",
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.4142 10.0986H78.9142V9.59863C78.9142 5.11026 82.5576 1.5 87.0228 1.5C91.488 1.5 95.1314 5.11026 95.1314 9.59863V10.0986H95.6314H104.24C104.97 10.0986 105.578 10.6861 105.578 11.4343V21.5143C105.578 22.2417 104.99 22.85 104.24 22.85H69.8378C69.1082 22.85 68.5 22.2625 68.5 21.5143V11.4343C68.5 10.7069 69.0873 10.0986 69.8378 10.0986H78.4142Z",
			fill: "#62B5A6",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.3111 5.63945V5.63953L87.32 5.63937C88.8679 5.61173 90.1222 6.85294 90.1222 8.45029C90.1222 10.0098 88.8709 11.2611 87.3111 11.2611C85.7546 11.2611 84.5 9.98027 84.5 8.45029C84.5 6.89076 85.7513 5.63945 87.3111 5.63945Z",
			fill: "#F9FAFD",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 47.5,
			y: 82.5,
			width: 79,
			height: 5,
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 47.5,
			y: 94.5,
			width: 79,
			height: 5,
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 47.5,
			y: 106.5,
			width: 79,
			height: 5,
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 47.5,
			y: 118.5,
			width: 64,
			height: 5,
			fill: "white",
			stroke: "black"
		})
	]
});
export default Svg404;
